import { useLocation } from "react-router-dom";

export const useCheckIsActiveItem = (path: string): boolean => {
  const { pathname } = useLocation();

  if (!path) return false;

  return pathname.includes(path);
};
